import React, { useState } from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { Button, Grid, TextField, Typography } from '@mui/material';
import OptionModal from './OptionModal';
import { GetUserData } from 'API/Ds Approval/api';
import { useEffect } from 'react';
import { Stack } from '@mui/system';
// import { useEffect ,useState} from 'react';

const FieldsTable = (props) => {
  const [option, setOption] = React.useState(null);
  const [userData, setUserData] = useState();
  const categories = ['General Information', 'Home Address', 'Retail Address', 'Banking Details', 'KYC Details'];
  const userType = sessionStorage.getItem('UserType');

  const gmDisplayData = [
    { label: 'User Type', field: 'distributor_services_type' },
    { label: 'Type of DS', field: 'distributor_type' },
    { label: 'Class of DS', field: 'distributor_class' },
    { label: 'First Name', field: 'first_name' },
    { label: 'Last Name', field: 'last_name' },
    { label: 'Email Address', field: 'email_address' },
    { label: 'Mobile Number', field: 'mobile_number_1' },
    { label: 'Address', field: 'home_address' },
    { label: 'Pincode', field: 'home_pincode' },
    { label: 'Region', field: 'home_region' },
    { label: 'State', field: 'home_state' },
    { label: 'District', field: 'home_district' },
    { label: 'Sub District', field: 'home_sub_district' },
    { label: 'Village/Town', field: 'home_city_village' }
  ];

  const handleSelect = (index) => {
    setOption(categories[index]);
  };


  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
    setOption(null);
  };

  React.useEffect(() => {
    if (option) handleClickOpen();
  }, [option]);

  useEffect(() => {
    GetUserData(props.selectedItem.user_id, setUserData);
  }, []);

  // const getCategories=(item)=>{
  //     return item._id===props.selectedItem.product_id
  // }

  // const getUniqueCategory=(item)=>{
  //     return item._id===props.selectedItem.product_id
  // }

  // const product=props.configData.find(getCategories)

  return userType === 'gm' ? (
    <Grid container spacing={1}>
      {gmDisplayData.map((item, index) => (
        <Grid item lg={4} md={6} xs={12} key={index}>
          <Stack gap={1}>
            <Typography variant="h5">{item.label}</Typography>
            <TextField
              size="small"
              value={props.selectedItem && props.selectedItem[item.field] ? props.selectedItem[item.field] : ''}
              inputProps={{
                readOnly: true
              }}
            />
          </Stack>
        </Grid>
      ))}
    </Grid>
  ) : (
    props && props.selectedItem && (
      <Table sx={{ minWidth: 650 }} size="small" aria-label="a dense table">
        <OptionModal
          open={open}
          handleClose={handleClose}
          userId={props.selectedItem.user_id}
          userData={userData}
          selected={option}
          data={
            option === 'Home Address'
              ? props && props.selectedItem && props.selectedItem.home_address
              : option === 'KYC Details'
              ? props && props.selectedItem && props.selectedItem.user_documents
              : option === 'Retail Address'
              ? props && props.selectedItem && props.selectedItem.retail_address
              : option === 'Banking Details'
              ? props && props.selectedItem && props.selectedItem.banking_details
              : option === 'General Information'
              ? props && props.selectedItem && props.selectedItem.general_information
              : props.selectedItem
          }
        />
        <TableHead>
          <TableRow>
            <TableCell>Fields</TableCell>
            <TableCell align="right">Actions</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {categories &&
            categories.map((row, index) => (
              <TableRow key={index} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                <TableCell component="th" scope="row">
                  {row}
                </TableCell>
                <TableCell align="right">
                  <Button variant="contained" color="secondary" sx={{
                  backgroundColor: '#592375',
                  color: '#FFFFFF',
                  borderRadius: '6px',
                  '&:hover': {
                    backgroundColor: '#592375'
                  }
                }} onClick={() => handleSelect(index)}>
                    View
                  </Button>
                </TableCell>
              </TableRow>
            ))}
        </TableBody>
      </Table>
    )
  );
};

export default FieldsTable;
